export default __webpack_public_path__ + "static/media/proxy-layer.85dc8e23.jpg";